import { combineReducers } from 'redux'
import backpack from './reducers/backpack.ts'
import codeClaimModal from './reducers/codeClaimModal'

export default combineReducers({
  backpack,
  codeClaimModal,
})
